var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourtPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#0B3BFE",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1875 45.3517C18.4181 44.6089 18.5132 43.3532 19.3858 42.7337L24.2279 39.2961C24.5105 39.0954 24.8979 39.1317 25.1381 39.381C25.3695 39.6213 25.3977 39.9912 25.2054 40.2636L21.7843 45.1078C21.1778 45.9666 19.9445 46.0824 19.1875 45.3517Z",
    stroke: "#3C1DC4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.334 33.1667L25.334 39.1667",
    stroke: "#3C1DC4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9061 33.2699C39.3793 35.7967 34.4926 35.9039 31.5448 32.9559C28.5968 30.0081 28.7039 25.1214 31.2308 22.5946C34.55 19.2753 40.7973 17.8076 43.7452 20.7555C46.6932 23.7035 45.2254 29.9507 41.9061 33.2699Z",
    stroke: "#3C1DC4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourtPerformance);
export default __webpack_public_path__ + "static/media/court-performance.5e2a6a35349d04f62b4d92bf8505db43.svg";
export { ForwardRef as ReactComponent };